import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavLogo,
  NavMenu,
  NavBtn,
  NavBtnLink
} from '../NavbarHome/NavbarHeaderElements';

const NavbarHome = ({ signoutBoolean }) => {
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo onClick={toggleHome} to='/'>
              Lay Trader, Inc.
            </NavLogo>
            {/* <MobileIcon onClick={toggle}>
              <FaBars />
            </MobileIcon>
            <NavMenu /> */}
            {signoutBoolean ? <NavBtn>
              <NavBtnLink to='/signin'>Sign Out</NavBtnLink>
            </NavBtn> : <></>
            }
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default NavbarHome;
